// extracted by mini-css-extract-plugin
module.exports = {"stickyButtonContainer":"az_Jbb","applyBtn":"az_Kbb"};